import { render, staticRenderFns } from "./trev-contract-product-selection.vue?vue&type=template&id=cbf85e36&"
import script from "./trev-contract-product-selection.vue?vue&type=script&lang=js&"
export * from "./trev-contract-product-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports